import React, { PropTypes } from 'react'

const LeftComponent = () => (
  <div className="container_bg">
    <div className="container_bg_info">
      <h2>LEARNING MADE EASY</h2>
      <p>ONLINE WEBINARS</p>
      <div className="container_images">
        <img className="container_bg_icons" src="/assets/img/pattern.svg" alt="bg" />
        <img className="container_bg_mac" src="/assets/img/landing-top-notebook.png" alt="mac" />
      </div>
    </div>
  </div>
)

// LeftComponent.propTypes = {
//   todos: PropTypes.arrayOf(PropTypes.shape({
//     id: PropTypes.number.isRequired,
//     completed: PropTypes.bool.isRequired,
//     text: PropTypes.string.isRequired
//   }).isRequired).isRequired,
//   onTodoClick: PropTypes.func.isRequired
// }

export default LeftComponent



/** WEBPACK FOOTER **
 ** ./src/components/Authorization/LeftComponent.js
 **/